    // import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Box, useTheme, InputBase, IconButton, Button } from "@mui/material";
// import { tokens } from "../../theme";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import Header from "../../components/Header";
// import SearchIcon from "@mui/icons-material/Search";
// import { getDescuento } from "../../services/descuento.services";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import "dayjs/locale/es";
// import { getMarcacionesView } from "../../services/marcaciones.services";
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
// } from '@mui/material';
// import ExcelJS from 'exceljs';
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";



// const Adicional = () => {
//   const [data, setData] = useState([]);
//   const [originalData, setOriginalData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [mesSeleccionado, setMesSeleccionado] = useState(dayjs());
//   const mes = mesSeleccionado.month() + 1; // dayjs es 0-indexed
//   const año = mesSeleccionado.year();
//   const [searchValue, setSearchValue] = useState("");
//   const datosFiltrados = filtrarPorMes(data, mes, año);
//   const empleadosTransformados = tablaPivote(datosFiltrados, mes, año);
//   const diasDelMes = new Date(año, mes, 0).getDate();
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   useEffect(() => {
//   const fetchData = async () => {
//     try {
//       const datos = await getMarcacionesView();
//       console.log("Marcaciones recibidas:", datos);
//       setOriginalData(datos);
//       setData(datos);
//     } catch (error) {
//       console.error("Error al obtener datos del backend:", error);
//     }
//   };
//   fetchData();
//   }, []);

//   function filtrarPorMes(data, mes, año) {
//   return data.filter(item => {
//     const entrada = new Date(item.entrada);
//     return (
//       entrada.getMonth() + 1 === mes &&
//       entrada.getFullYear() === año
//     );
//   });
// }


  
//   function tablaPivote(data, mes, año) {
//     const diasDelMes = new Date(año, mes, 0).getDate();
//     const empleados = {};
    
//     data.forEach(item => {
//       const entrada = new Date(item.entrada);
//       const dia = entrada.getDate(); // día del mes
//       const id = item.Id_empleado;
    
//       if (!empleados[id]) {
//         empleados[id] = {
//           id_empleado: id,
//           nombre: item.funcionario,
//           dias: Array(diasDelMes).fill(0), // Inicializamos todos los días con 0
//           total: 0
//         };
//       }
//       const monto = Number(item.adicional_nocturno);
//       empleados[id].dias[dia - 1] = monto;
//       empleados[id].dias[dia - 1] = Number(item.adicional_nocturno);  // asignamos el monto
//       empleados[id].total += monto;
//     });
  
//     return Object.values(empleados);
//   }

//     // Definimos dinámicamente las columnas del DataGrid
//   const columns = [
//     { field: "nombre", headerName: "Empleado", width: 200 },
//     ...Array.from({ length: diasDelMes }, (_, i) => ({
//       field: `dia_${i + 1}`,
//       headerName: `${i + 1}`,
//       width: 80,
//       headerAlign: "center", // centra cabecera
//       align: "center",       
//       filterable: false,  // ✅ quita filtro en columnas de días
//       sortable: false,
//       disableColumnMenu: true,
//     })),
//     { field: "total", headerName: "Total", width: 120 , headerAlign: "center", // centra cabecera
//       align: "center", },
//   ];

//   const empleadosFiltrados = empleadosTransformados
//     .filter((emp) => emp.total > 0)
//     .filter((emp) =>
//       emp.nombre.toLowerCase().includes(searchValue.toLowerCase())
//   );


//   // Mapeamos los empleados transformados al formato del DataGrid
//  const rows = empleadosFiltrados.map((emp) => {
//   const row = {
//     id: emp.id_empleado,
//     nombre: emp.nombre,
//     total: emp.total.toLocaleString("de-DE"),
//   };

//   emp.dias.forEach((monto, i) => {
//     row[`dia_${i + 1}`] = monto > 0 ? monto.toLocaleString("de-DE") : "—";
//   });

//   return row;
// });

//   const handleSearchChange = (event) => {
//   setSearchValue(event.target.value);
//   };
  

//   const handleExport = async () => {
//   // 🔹 Crear libro y hoja
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Adicional");

//   // 🔹 Encabezados
//   const headers = columns.map((col) => col.headerName);
//   worksheet.addRow(headers);

//   // 🔹 Estilo de cabecera
//   headers.forEach((_, index) => {
//     const cell = worksheet.getRow(1).getCell(index + 1);
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "143F04" }, // Verde oscuro
//     };
//     cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
//     cell.alignment = { horizontal: "center", vertical: "middle" };
//     cell.border = {
//       top: { style: "thin", color: { argb: "000000" } },
//       left: { style: "thin", color: { argb: "000000" } },
//       bottom: { style: "thin", color: { argb: "000000" } },
//       right: { style: "thin", color: { argb: "000000" } },
//     };
//   });

//   // 🔹 Filas de datos
//   rows.forEach((row) => {
//     worksheet.addRow(columns.map((col) => row[col.field] ?? ""));
//   });

//   // 🔹 Bordes y alineación para todas las celdas con datos
//   worksheet.eachRow((row, rowNumber) => {
//     row.eachCell((cell, colNumber) => {
//       // Bordes en TODAS las celdas
//       cell.border = {
//         top: { style: "thin", color: { argb: "000000" } },
//         left: { style: "thin", color: { argb: "000000" } },
//         bottom: { style: "thin", color: { argb: "000000" } },
//         right: { style: "thin", color: { argb: "000000" } },
//       };

//       // Centrar montos (todas las columnas excepto la de nombre)
//       if (colNumber > 1) {
//         cell.alignment = { horizontal: "center", vertical: "middle" };
//       }
//     });
//   });

//   // 🔹 Ajustar ancho de columnas
//   worksheet.columns.forEach((col, index) => {
//     col.width = index === 0 ? 25 : 12;
//   });

//   // 🔹 Generar archivo
//   const buffer = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buffer], { type: "application/octet-stream" });
//   saveAs(blob, `adicional_nocturno_${mes}-${año}.xlsx`);
// };



// return (
//     <Box m="20px">
//       <Box display="flex" justifyContent="space-between" p={0}>
//         <Header title="Adicional Nocturno" subtitle="Relatorio de Adicional Nocturno" />
//         <Box display="flex" alignItems="center">
//           <Box display="flex" alignItems="center" sx={{width: "100%"}}>
//             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
//               <Box sx={{ minWidth: 157 }}>
//                 <DatePicker
//                   views={["year", "month"]}
//                   label="Seleccionar mes"
//                   value={mesSeleccionado}
//                   onChange={(newValue) => setMesSeleccionado(newValue)}
//                   slotProps={{
//                     textField: { size: "medium" }, // tamaño del input
//                   }}
//                 />
//               </Box>
//             </LocalizationProvider>
//             <Box sx={{
//               marginRight:"2%",
//               marginLeft:"2%",
      
//         }}>
//                     <Button sx={{
//                       background:"#143f04",
//                       width:"100%",
//                       height:"3rem!important",
//                       color:"white",
//                       borderRadius:"8px", "&:hover": {
//                         background: "#36a60f", // Color de fondo cuando el botón está en hover
//                       },
                      
//                     }} onClick={handleExport} variant="contained" color="primary">
//                       <img
//                         src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
//                         alt="Excel Icon"
//                         style={{ width: 24, height: 24, marginRight: 8 }}
//                       />
//                       Exportar
//                     </Button>
//                     </Box>
//                 <Box
//                   display="flex"
//                   backgroundColor={colors.primary[400]}
//                   borderRadius="3px"
//                   height={"40%"}
//                   width={"90%"}
//                   ml={1}
//                 >
//                   <InputBase
//                     sx={{ ml: 2, flex: 1 }}
//                     placeholder="Buscar"
//                     value={searchValue}
//                     onChange={handleSearchChange}
//                   />
//                   <IconButton type="button" sx={{ p: 1 }}>
//                     <SearchIcon />
//                   </IconButton>
//               </Box>
//             </Box>
//         </Box>
//       </Box>

//       <Box mt={4} sx={{
//           "& .MuiDataGrid-root": {
//             border: "none",
//           },
//           "& .MuiDataGrid-cell": {
//             borderBottom: "none",
//           },
//           "& .name-column--cell": {
//             color: colors.greenAccent[300],
//           },
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: colors.blueAccent[900],
//             borderBottom: "none",
//           },
//           "& .MuiDataGrid-virtualScroller": {
//             backgroundColor: colors.primary[400],
//           },
//           "& .MuiDataGrid-footerContainer": {
//             borderTop: "none",
//             backgroundColor: colors.blueAccent[900],
//           },
//           "& .MuiCheckbox-root": {
//             color: `${colors.greenAccent[200]} !important`,
//           },
//           "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//             color: `${colors.grey[100]} !important`,
//           },
//           height: "70vh", width: "100%" 
//         }}>
//         <DataGrid
//           rows={rows}
//           columns={columns}
//           components={{ Toolbar: GridToolbar }}
//           disableRowSelectionOnClick
//           sx={{
//             border: "1px solid #e0e0e0", // borde general de la tabla
//             "& .MuiDataGrid-cell": {
//               borderRight: "1px solid #f5f5f5", // borde entre columnas
//             },
//             "& .MuiDataGrid-columnHeader": {
//               borderRight: "1px solid #f5f5f5", // borde entre columnas en header
//             },
//             "& .MuiDataGrid-row": {
//               borderBottom: "1px solid #f5f5f5", // borde entre filas
//             },
//           }}
//         />
//       </Box>
//     </Box>
//   );
// };

// export default Adicional;



import React, { useState, useEffect } from "react";
    import axios from "axios";
    import { Box, useTheme, InputBase, IconButton, Button } from "@mui/material";
    import { tokens } from "../../theme";
    import { DataGrid, GridToolbar } from "@mui/x-data-grid";
    import Header from "../../components/Header";
    import SearchIcon from "@mui/icons-material/Search";
    import { getDescuento } from "../../services/descuento.services";
    import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
    import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
    import { DatePicker } from "@mui/x-date-pickers/DatePicker";
    import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
    import dayjs from "dayjs";
    import "dayjs/locale/es";
    import { getMarcacionesView } from "../../services/marcaciones.services";
    import {
      Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    } from '@mui/material';
    import ExcelJS from 'exceljs';
    import * as XLSX from "xlsx";
    import { saveAs } from "file-saver";



    const Adicional = () => {
      const [data, setData] = useState([]);
      const [originalData, setOriginalData] = useState([]);
      const [filteredData, setFilteredData] = useState([]);
      const [mesSeleccionado, setMesSeleccionado] = useState(dayjs());
      const mes = mesSeleccionado.month() + 1; // dayjs es 0-indexed
      const año = mesSeleccionado.year();
      const [searchValue, setSearchValue] = useState("");
      const datosFiltrados = filtrarPorMes(data, mes, año);
      const empleadosTransformados = tablaPivote(datosFiltrados, mes, año);
      const diasDelMes = new Date(año, mes, 0).getDate();
      const theme = useTheme();
      const colors = tokens(theme.palette.mode);

      useEffect(() => {
      const fetchData = async () => {
        try {
          const datos = await getMarcacionesView();
          // console.log("Marcaciones recibidas:", datos);
          setOriginalData(datos);
          setData(datos);
        } catch (error) {
          console.error("Error al obtener datos del backend:", error);
        }
      };
      fetchData();
      }, []);

      function filtrarPorMes(data, mes, año) {
      return data.filter(item => {
        const entrada = new Date(item.entrada);
        return (
          entrada.getMonth() + 1 === mes &&
          entrada.getFullYear() === año
        );
      });
    }


      function tablaPivote(data, mes, año) {
    const diasDelMes = new Date(año, mes, 0).getDate();
    const empleados = {};

    // 🔹 Agrupar registros por empleado
    data.forEach(item => {
      const entrada = new Date(item.entrada);
      const dia = entrada.getDate();
      const id = item.Id_empleado;

      // Ignorar domingos (no se pagan)
      const esDomingo = entrada.getDay() === 0;
      if (esDomingo) return;

      if (!empleados[id]) {
        empleados[id] = {
          id_empleado: id,
          nombre: item.funcionario,
          dias: Array(diasDelMes).fill(0),
        };
      }

      // Guardar el valor del adicional en el día correspondiente
      empleados[id].dias[dia - 1] = Number(item.adicional_nocturno);
    });

  // 🔹 Procesar cada empleado para calcular el total a pagar
    const empleadosProcesados = Object.values(empleados).map(emp => {
      // Días en los que efectivamente trabajó (tienen monto > 0)
      const diasTrabajados = emp.dias.filter(m => m > 0);
      // 🔹 Sumar solo los días seleccionados (menores si se pasa del tope)
      const total = diasTrabajados.reduce((sum, m) => sum + m, 0);

      return {
        ...emp,
        total,
      };
    });

    return empleadosProcesados;
  }

        // Definimos dinámicamente las columnas del DataGrid
      const columns = [
        { field: "nombre", headerName: "Empleado", width: 200 },
        ...Array.from({ length: diasDelMes }, (_, i) => ({
          field: `dia_${i + 1}`,
          headerName: `${i + 1}`,
          width: 80,
          headerAlign: "center", // centra cabecera
          align: "center",       
          filterable: false,  // ✅ quita filtro en columnas de días
          sortable: false,
          disableColumnMenu: true,
        })),
        { field: "total", headerName: "Total", width: 120 , headerAlign: "center", // centra cabecera
          align: "center" }
      ];

      const empleadosFiltrados = empleadosTransformados
        .filter((emp) => emp.total > 0)
        .filter((emp) =>
          emp.nombre.toLowerCase().includes(searchValue.toLowerCase())
      );


      // Mapeamos los empleados transformados al formato del DataGrid
    const rows = empleadosFiltrados.map((emp) => {
      const row = {
        id: emp.id_empleado,
        nombre: emp.nombre,
        total: emp.total.toLocaleString("de-DE"),
      };

      emp.dias.forEach((monto, i) => {
        row[`dia_${i + 1}`] = monto > 0 ? monto.toLocaleString("de-DE") : "—";
      });

      return row;
    });

      const handleSearchChange = (event) => {
      setSearchValue(event.target.value);
      };
      

      const handleExport = async () => {
      // 🔹 Crear libro y hoja
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Adicional");

      // 🔹 Encabezados
      const headers = columns.map((col) => col.headerName);
      worksheet.addRow(headers);

      // 🔹 Estilo de cabecera
      headers.forEach((_, index) => {
        const cell = worksheet.getRow(1).getCell(index + 1);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "143F04" }, // Verde oscuro
        };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };
      });

      // 🔹 Filas de datos
      rows.forEach((row) => {
        worksheet.addRow(columns.map((col) => row[col.field] ?? ""));
      });

      // 🔹 Bordes y alineación para todas las celdas con datos
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          // Bordes en TODAS las celdas
          cell.border = {
            top: { style: "thin", color: { argb: "000000" } },
            left: { style: "thin", color: { argb: "000000" } },
            bottom: { style: "thin", color: { argb: "000000" } },
            right: { style: "thin", color: { argb: "000000" } },
          };

          // Centrar montos (todas las columnas excepto la de nombre)
          if (colNumber > 1) {
            cell.alignment = { horizontal: "center", vertical: "middle" };
          }
        });
      });

      // 🔹 Ajustar ancho de columnas
      worksheet.columns.forEach((col, index) => {
        col.width = index === 0 ? 25 : 12;
      });

      // 🔹 Generar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, `adicional_nocturno_${mes}-${año}.xlsx`);
    };



    return (
        <Box m="20px">
          <Box display="flex" justifyContent="space-between" p={0}>
            <Header title="Adicional Nocturno" subtitle="Relatorio de Adicional Nocturno" />
            <Box display="flex" alignItems="center">
              <Box display="flex" alignItems="center" sx={{width: "100%"}}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                  <Box sx={{ minWidth: 157 }}>
                    <DatePicker
                      views={["year", "month"]}
                      label="Seleccionar mes"
                      value={mesSeleccionado}
                      onChange={(newValue) => setMesSeleccionado(newValue)}
                      slotProps={{
                        textField: { size: "medium" }, // tamaño del input
                      }}
                    />
                  </Box>
                </LocalizationProvider>
                <Box sx={{
                  marginRight:"2%",
                  marginLeft:"2%",
          
            }}>
                        <Button sx={{
                          background:"#143f04",
                          width:"100%",
                          height:"3rem!important",
                          color:"white",
                          borderRadius:"8px", "&:hover": {
                            background: "#36a60f", // Color de fondo cuando el botón está en hover
                          },
                          
                        }} onClick={handleExport} variant="contained" color="primary">
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
                            alt="Excel Icon"
                            style={{ width: 24, height: 24, marginRight: 8 }}
                          />
                          Exportar
                        </Button>
                        </Box>
                    <Box
                      display="flex"
                      backgroundColor={colors.primary[400]}
                      borderRadius="3px"
                      height={"40%"}
                      width={"90%"}
                      ml={1}
                    >
                      <InputBase
                        sx={{ ml: 2, flex: 1 }}
                        placeholder="Buscar"
                        value={searchValue}
                        onChange={handleSearchChange}
                      />
                      <IconButton type="button" sx={{ p: 1 }}>
                        <SearchIcon />
                      </IconButton>
                  </Box>
                </Box>
            </Box>
          </Box>

          <Box mt={4} sx={{
              "& .MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .name-column--cell": {
                color: colors.greenAccent[300],
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: colors.blueAccent[900],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: colors.primary[400],
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "none",
                backgroundColor: colors.blueAccent[900],
              },
              "& .MuiCheckbox-root": {
                color: `${colors.greenAccent[200]} !important`,
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${colors.grey[100]} !important`,
              },
              height: "70vh", width: "100%" 
            }}>
            <DataGrid
              rows={rows}
              columns={columns}
              components={{ Toolbar: GridToolbar }}
              disableRowSelectionOnClick
              sx={{
                border: "1px solid #e0e0e0", // borde general de la tabla
                "& .MuiDataGrid-cell": {
                  borderRight: "1px solid #f5f5f5", // borde entre columnas
                },
                "& .MuiDataGrid-columnHeader": {
                  borderRight: "1px solid #f5f5f5", // borde entre columnas en header
                },
                "& .MuiDataGrid-row": {
                  borderBottom: "1px solid #f5f5f5", // borde entre filas
                },
              }}
            />
          </Box>
        </Box>
      );
    };

    export default Adicional;